var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('robot-msg-tmpl',{attrs:{"robotImg":_vm.robotImg},scopedSlots:_vm._u([{key:"message",fn:function(){return [_c('answer-item',[_c('img',{attrs:{"src":_vm.message},on:{"click":function($event){return _vm.previewImg(_vm.message)}}})])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }